/**
 * 学习模式，0 - 正常学习； 1 - 预览
 */
enum LearningMode {
  /**
   * 正常学习
   */
  Learning = 0,
  /**
   * 预览
   */
  Preview = 1
}

export default LearningMode
